import { useCallback, useEffect, useState } from 'react';
import { API_BASE } from '../config';
import { useAuth } from '../contexts/AuthContext';
import { USER_NOTES_CHANGED_EVENT } from '../utils/user-notes-events';

export function useUserNotesCount(): number {
  const { token } = useAuth();
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async (): Promise<void> => {
    if (!token) {
      setCount(0);
      return;
    }
    try {
      const response = await fetch(`${API_BASE}/api/notes`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) {
        setCount(0);
        return;
      }
      const data = await response.json();
      setCount(Array.isArray(data.notes) ? data.notes.length : 0);
    } catch {
      setCount(0);
    }
  }, [token]);

  useEffect(() => {
    void fetchCount();
    const handleChanged = (): void => {
      void fetchCount();
    };
    window.addEventListener(USER_NOTES_CHANGED_EVENT, handleChanged);
    return () => {
      window.removeEventListener(USER_NOTES_CHANGED_EVENT, handleChanged);
    };
  }, [fetchCount]);

  return count;
}
